document.addEventListener('turbolinks:load', () => {
    const selfGuidedTourSelectPreview = document.getElementById('selfGuidedTourSelectPreview')
    const selfGuidedTourSelectPreviewTop = document.getElementById('selfGuidedTourSelectPreviewTop')
    const tourScrollList = document.getElementById('tourScrollList')
    const sgScreen = document.getElementById('sgScreen')

    if (selfGuidedTourSelectPreview !== null && sgScreen !== null && selfGuidedTourSelectPreviewTop !== null &&
        tourScrollList !== null) {
        handleScroll()
    }

    // change top-bar shadow if users scrolls
    function handleScroll() {
        tourScrollList.addEventListener("scroll", (e) => {
            if (tourScrollList.scrollTop === 0) {
                selfGuidedTourSelectPreviewTop.classList.remove('my-tour-app-shadow')
            } else {
                selfGuidedTourSelectPreviewTop.classList.add('my-tour-app-shadow')
            }

        });
    }

})